import Raven from 'raven-js';
import { useIsComponentEnabled } from '../hooks/useIsComponentEnabled';
import Metrics from '../shared/metrics';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export function StatusVerifiedComponent({
  children,
  component
}) {
  const isEnabled = useIsComponentEnabled(component);
  if (!isEnabled) {
    Raven.captureMessage('Blocking component render based on component status', {
      extra: {
        component
      },
      level: 'critical'
    });
    Metrics.counter('component-render-blocked', {
      component: component.toString()
    }).increment();
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}